import { Flex } from 'component-library/components/layout/Flex';
import { Link } from 'component-library/components/links/Link';
import { Body } from 'component-library/components/typography/Body';
import { device } from 'component-library/styles/device';
import {
  formattedRetirablePhoneNumber,
  retirablePhoneNumber,
} from 'helpers/businessConstants';
import React, { FC } from 'react';
import styled from 'styled-components';

const SERVICES_LINKS = {
  title: 'Services',
  contents: [
    {
      label: 'Advisor',
      to: '/advisor',
    },
    {
      label: 'Income',
      to: '/income',
    },
    {
      label: 'Investing',
      to: '/investing',
    },
  ],
};

const COMPANY_LINKS = {
  title: 'Company',
  contents: [
    {
      label: 'About Us',
      to: '/about-us',
    },
    {
      label: 'Careers',
      to: 'https://angel.co/company/retirable/jobs',
    },
    {
      label: 'Press',
      to: 'mailto:press@retirable.com',
    },
    {
      label: 'Medicare',
      to: '/partners/medicare',
    },
  ],
};

const LEARN_LINKS = {
  title: 'Learn',
  contents: [
    {
      label: 'FAQ',
      to: '/faq',
    },
    {
      label: 'Blog',
      to: '/advice',
    },
  ],
};

const CONTACT_LINKS = {
  title: 'Contact',
  contents: [
    {
      label: 'info@retirable.com',
      to: 'mailto:info@retirable.com',
    },
    {
      label: formattedRetirablePhoneNumber,
      to: `tel:${retirablePhoneNumber}`,
    },
  ],
};

const ALL_LINKS = [SERVICES_LINKS, COMPANY_LINKS, LEARN_LINKS, CONTACT_LINKS];

const LinksWrapper = styled(Flex)`
  flex-wrap: wrap;
  ${`@media ${device.xl}`} {
    flex-wrap: unset;
    width: 100%;
  }
`;

const LinkSection = styled.div`
  flex-basis: 50%;
`;

interface LinksProps {
  contactOnly?: boolean;
}

export const Links: FC<LinksProps> = ({ contactOnly = false }) => (
  <LinksWrapper>
    {(contactOnly ? [CONTACT_LINKS] : ALL_LINKS).map((link, idx) => (
      <LinkSection key={idx}>
        <Body marginBottom={24} medium variant={1}>
          {link.title}
        </Body>
        {link.contents.map((content, idx) => (
          <Link key={idx} variant={3} marginBottom={16} to={content.to}>
            {content.label}
          </Link>
        ))}
      </LinkSection>
    ))}
  </LinksWrapper>
);
